module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-4-m3.5d71ac30.jpg";